import { Card, CardActions, CardContent, Grid, Skeleton } from "@mui/material";

const BookCardSkeleton = () => {
  return (
      <Grid component={Card}>
          <Skeleton sx={{ height: 190 }} animation="wave" variant="rectangular" />
          <CardContent>
              <>
                  <Skeleton animation="wave" height={10} style={{ marginBottom: 6 }} />
                  <Skeleton animation="wave" height={10} width="80%" />
              </>
          </CardContent>
          <CardActions>
              <>
                  <Skeleton animation="wave" height={10} width='40%' />
                  <Skeleton animation="wave" height={10} width="20%" />
              </>
          </CardActions>
      </Grid>
  )
}

export default BookCardSkeleton;
